var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Page introuvable")]),_c('div',[_vm._v("La page que vous recherchez est introuvable sur ce site")])])}]

export { render, staticRenderFns }